export const sanitizeSmsBodyAndAppendSuffix = (str, suffix) => {
  if (!str) return '';
  str = str.trim();
  return `${str}${suffix}`;
};
